import CheckIcon from '@/common/assets/icons/greenCheckIcon.svg?react';
import { Flex, Stack } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import useAcceptFileMutation from '@/modules/FileList/hooks/useAcceptFileMutation.ts';
import LoadingButton from '@/common/components/base/button/loadingButton.tsx';
import { NotRelatedAcceptFileModalProps } from '@/modules/FileList/components/modals/acceptFileModals/AcceptFileModals.type.ts';

export default ({ closeModal, fileId }: NotRelatedAcceptFileModalProps) => {
  const { mutate, isPending } = useAcceptFileMutation();
  const acceptFile = () => {
    mutate(
      {
        fileId,
      },
      {
        onSuccess: closeModal,
      },
    );
  };
  return (
    <Stack gap="20px" alignItems="center">
      <CheckIcon />
      <Typography>آیا از قبول پرونده مطمئن هستید؟</Typography>
      <Typography textStyle="b2" color="black-3">
        در صورت قبول ، پرونده به بخش پرونده‌های در حال اجرا منتقل می شود.
      </Typography>
      <Flex my="20px" width="100%" gap="15px">
        <Button
          onClick={closeModal}
          fullWidth
          color="common"
          variant="outlined"
          disabled={isPending}
        >
          انصراف
        </Button>
        <LoadingButton loading={isPending} onClick={acceptFile} fullWidth>
          قبول پرونده
        </LoadingButton>
      </Flex>
    </Stack>
  );
};
